<template>
	<div>
		<v-card-text class="py-0">
			<v-btn size="36" variant="text" icon @click="toggleExpansion" class="ml-0">
				<v-icon>
					mdi-play {{ expansion ? "mdi-rotate-90" : "" }}
				</v-icon>
			</v-btn>
			<span>{{ getTitle() }}</span>
		</v-card-text>

		<v-expand-transition>
			<div v-show="expansion" class="mx-3 mb-3">
				<v-card-text v-if="solidMeshList.length == 0" class="pa-0 pl-10">
					{{ $t("NO_DATA") }}
				</v-card-text>
				<solid-mesh-list-item v-for="solidMesh in solidMeshList" :key="solidMesh.id" :solidMeshId="solidMesh.id"
					class="pa-0 ml-3">
				</solid-mesh-list-item>
			</div>
		</v-expand-transition>
	</div>
</template>

<script>
import { ObjectType } from "@/models/objects/types";
import { mapActions } from "vuex";
import SolidMeshListItem from "./SolidMeshListItem.vue";

export default {
	name: "SolidMeshList",
	components: {
		SolidMeshListItem,
	},
	data() {
		return {
			expansion: false,
		};
	},
	computed: {
		solidMeshList() {
			return this.$store.state.object.objects.filter(
				(obj) => obj.type === ObjectType.SOLID_MESH,
			);
		},
	},
	methods: {
		...mapActions("object", ["get_obj_list"]),

		getTitle() {
			return `${this.$t("SIMPLE_STRUCTURE_DATA")}`;
		},

		toggleExpansion() {
			this.expansion = !this.expansion;
		},

		async refreshSolidMeshList() {
			try {
				await this.get_obj_list(this.$route.query.siteId);
				this.$store.commit("set_snackbar", {
					text: `${this.$t("GET_DATA")} ${this.$t("successful")}`,
					color: "rgba(0, 153, 0, 0.72)",
				});
				console.log("solidMeshList", this.solidMeshList);
			} catch (error) {
				console.error("Failed to refresh solid mesh list:", error);
				this.$store.commit("set_snackbar", {
					text: `${this.$t("GET_DATA")} ${this.$t("failed")}`,
					color: "rgba(153, 0, 0, 0.72)",
				});
			}
		},
	},
};
</script>

<style scoped>
.panel-main-item {
	margin-bottom: 8px;
}

.v-list-item {
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.v-list-item:last-child {
	border-bottom: none;
}
</style>
